import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, BrainIcon, SparklesIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SocialProofSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full py-8 sm:py-14" data-id="element-320">
      <div className="max-w-6xl mx-auto px-6" data-id="element-321">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-322">
          {/* Card 1 — Shamanic Wisdom */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-323">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-purple-electric/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-324" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-325">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-electric to-transparent" data-id="element-326" />
              <div className="flex flex-col items-center text-center" data-id="element-327">
                <div className="w-12 h-12 rounded-full bg-purple-electric/10 flex items-center justify-center mb-5" data-id="element-328">
                  <FlameIcon className="w-6 h-6 text-purple-electric" data-id="element-329" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-330">
                  {t('social.years')}
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-331">
                  {t('social.yearsDesc')}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 2 — Neuroscience */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-332">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-gold/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-333" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-334">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-335" />
              <div className="flex flex-col items-center text-center" data-id="element-336">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mb-5" data-id="element-337">
                  <BrainIcon className="w-6 h-6 text-gold" data-id="element-338" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-339">
                  {t('social.evidence')}
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-340">
                  {t('social.evidenceDesc')}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 3 — Your Body */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-341">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-astral/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-342" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-343">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-astral to-transparent" data-id="element-344" />
              <div className="flex flex-col items-center text-center" data-id="element-345">
                <div className="w-12 h-12 rounded-full bg-astral/10 flex items-center justify-center mb-5" data-id="element-346">
                  <SparklesIcon className="w-6 h-6 text-astral" data-id="element-347" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-348">
                  {t('social.body')}
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-349">
                  {t('social.bodyDesc')}
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}